import moment from 'moment-timezone';
import { insidePolygon } from "geolocation-utils";
import { defaultAgent, apiResponse } from '../helpers/web-agent';
import { toastError, toastSuccess } from './toast';
import { tokenExpired } from './auth';
import { subscribe, unsubscribe } from "../actions/socket";
import { parseLoadFromManualForDashboard } from '../interceptors/load';
import {
    getSearchDateRange, isPlannedOrTodate, isElasticLoad, isToday, isUUID
} from '../helpers/common';
import { FIELD_STATUS_UPDATED, RECORD_FOUND } from '../constants/messages';
import {
    RANGE_TYPE_CUSTOM, GROUP_DASHBOARD_ANALYZE_KPI, API_DATE_FORMAT
} from '../constants';
import *  as actionTypes from '../constants/action-types';
import { getAnalyzeTopics } from './analyze';

//---------------------------COMMON-------------------------------------------
export const setFarmId = farmId => ({ type: actionTypes.DASHBOARD_SET_FARM_ID, farmId });

export const planTypeList = data => ({ type: actionTypes.DASHBOARD_GET_PLAN_TYPE_LIST, payload: data });

export const setMainBoardActiveTab = activeTab => ({ type: actionTypes.DASHBOARD_SET_ACTIVE_TAB, activeTab });

export const plannedDateRequest = (id) => ({ type: actionTypes.DASHBOARD_GET_PLANNED_DATE_REQUEST, id });

export const plannedDate = (id, data) => ({ type: actionTypes.DASHBOARD_GET_PLANNED_DATE, id, payload: data });

export const addRequestId = (requestId) => ({ type: actionTypes.DASHBOARD_ADD_REQUEST_ID, requestId });

export const clearRequestIds = () => ({ type: actionTypes.DASHBOARD_CLEAR_REQUEST_IDS });

export const refreshDashboard = () => ({ type: actionTypes.DASHBOARD_REFRESH });

export const clearDashBoard = (clearAll) => ({ type: actionTypes.DASHBOARD_CLEAR, clearAll });

//-------------------------LEADER BOARD-----------------------------------------
export const setCollapseLeaderBoard = () => ({ type: actionTypes.DASHBOARD_SET_COLLAPSE_LEADER_BOARD });

export const setLeaderBoardSelectedWorkType = data => ({ type: actionTypes.DASHBOARD_SET_SELECTED_WORK_TYPE_LEADERBOARD, payload: data });

export const equipmentGroupListRequest = (isRequest = true) => ({ type: actionTypes.DASHBOARD_GET_EG_LIST_REQUEST, isRequest });

export const equipmentGroupList = data => ({ type: actionTypes.DASHBOARD_GET_EG_LIST, payload: data });

export const manualLoadRequestForLeaderBoard = (loadType) => ({ type: actionTypes.DASHBOARD_GET_MANUAL_LOAD_REQUEST_FOR_LEADERBOARD, loadType });

export const manualLoadForLeaderBoard = (loadType, data) => ({ type: actionTypes.DASHBOARD_GET_MANUAL_LOAD_FOR_LEADERBOARD, loadType, payload: data });

export const automaticEgLoadRequest = () => ({ type: actionTypes.DASHBOARD_GET_AUTOMATIC_EG_LOAD_REQUEST });

export const automaticEgLoad = (data) => ({ type: actionTypes.DASHBOARD_GET_AUTOMATIC_EG_LOAD, payload: data });

export const sourceEgElasticdataRequest = () => ({ type: actionTypes.DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA_REQUEST });

export const sourceEgElasticdata = (data) => ({ type: actionTypes.DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA, payload: data });

export const egSpeedDataRequest = payload => ({ type: actionTypes.DASHBOARD_GET_EG_SPEED_REQUEST, payload });

export const egSpeedData = payload => ({ type: actionTypes.DASHBOARD_GET_EG_SPEED, payload });

//--------------------------CREWS----------------------------------------------
export const setCrewSelectedPlanType = data => ({ type: actionTypes.DASHBOARD_SET_SELECTED_PLAN_TYPE_FOR_CREW, payload: data });

export const setSelectedCrews = data => ({ type: actionTypes.DASHBOARD_SET_SELECTED_CREWS, payload: data });

export const setIncludeEndedCrew = data => ({ type: actionTypes.DASHBOARD_INCLUDE_ENDED_CREW, payload: data });

export const crewListRequest = () => ({ type: actionTypes.DASHBOARD_GET_CREW_LIST_REQUEST });

export const crewList = data => ({ type: actionTypes.DASHBOARD_GET_CREW_LIST, payload: data });

export const crewSummaryRequest = (crewId) => ({ type: actionTypes.DASHBOARD_GET_CREW_SUMMARY_REQUEST, crewId });

export const crewSummary = (crewId, data) => ({ type: actionTypes.DASHBOARD_GET_CREW_SUMMARY, crewId, payload: data });

export const crewDonutRequest = (crewId) => ({ type: actionTypes.DASHBOARD_GET_CREW_DONUT_REQUEST, crewId });

export const crewDonut = (crewId, data) => ({ type: actionTypes.DASHBOARD_GET_CREW_DONUT, crewId, payload: data });

export const crewGraphRequest = (crewId) => ({ type: actionTypes.DASHBOARD_GET_CREW_GRAPH_REQUEST, crewId });

export const crewGraph = (crewId, data) => ({ type: actionTypes.DASHBOARD_GET_CREW_GRAPH, crewId, payload: data });

export const crewElasticDataRequest = (crewId, elasticType) => ({ type: actionTypes.DASHBOARD_GET_CREW_ELASTIC_DATA_REQUEST, crewId, elasticType });

export const crewElasticData = (crewId, elasticType, elastic) => ({ type: actionTypes.DASHBOARD_GET_CREW_ELASTIC_DATA, crewId, elasticType, elastic });

//-----------------------------------FIELDS--------------------------------------
export const setFieldSelectedWorkType = data => ({ type: actionTypes.DASHBOARD_SET_SELECTED_WORK_TYPE_FOR_FIELD, payload: data });

export const setSelectedFields = data => ({ type: actionTypes.DASHBOARD_SET_SELECTED_FIELDS, payload: data });

export const setFilteredFields = data => ({ type: actionTypes.DASHBOARD_SET_FILTERED_FIELDS, payload: data });

export const setSortBy = data => ({ type: actionTypes.DASHBOARD_SET_SORT_BY, payload: data });

export const fieldEquipmentGroupListRequest = (isRequest = true) => ({ type: actionTypes.DASHBOARD_GET_EG_LIST_REQUEST_FOR_FIELD, isRequest });

export const fieldEquipmentGroupList = data => ({ type: actionTypes.DASHBOARD_GET_EG_LIST_FOR_FIELD, payload: data });

export const regionListRequest = () => ({ type: actionTypes.DASHBOARD_GET_REGION_LIST_REQUEST });

export const regionList = (data) => ({ type: actionTypes.DASHBOARD_GET_REGION_LIST, payload: data });

export const workedAcresRequest = (payload) => ({ type: actionTypes.DASHBOARD_GET_WORKED_ACRES_REQUEST, payload });

export const workedAcres = (data) => ({ type: actionTypes.DASHBOARD_GET_WORKED_ACRES, payload: data });

export const egWorkedAcresRequest = (shapeRefId, workTypeIds) => ({ type: actionTypes.DASHBOARD_GET_EG_WORED_ACRES_REQUEST, shapeRefId, workTypeIds });

export const egWorkedAcres = (shapeRefId, shapeGroupId, workTypeIds, data) => ({ type: actionTypes.DASHBOARD_GET_EG_WORED_ACRES, shapeRefId, shapeGroupId, workTypeIds, payload: data });

export const fieldLoadRequest = () => ({ type: actionTypes.DASHBOARD_GET_FIELD_LOADS_REQUEST });

export const fieldLoads = payload => ({ type: actionTypes.DASHBOARD_GET_FIELD_LOADS, payload });

export const dashboardTareLoadRequest = () => ({ type: actionTypes.DASHBOARD_GET_TARE_LOADS_REQUEST });

export const dashboardTareLoads = payload => ({ type: actionTypes.DASHBOARD_GET_TARE_LOADS, payload });

export const fieldLoadsTodate = payload => ({ type: actionTypes.DASHBOARD_GET_FIELD_LOADS_TODATE, payload });

export const updateFieldWorkStatusSuccess = (data) => ({ type: actionTypes.UPDATE_DASHBOARD_FIELD_WORK_STATUS_SUCCESS, payload: data });

//-----------------------------------LOADS-------------------------------------------
export const setOffloadListRequesting = () => ({ type: actionTypes.DASHBOARD_SET_OFFLOAD_REQUEST });

export const setOffloadList = payload => ({ type: actionTypes.DASHBOARD_SET_OFFLOAD_LIST, payload });

export const setOffloadReportRequesting = () => ({ type: actionTypes.DASHBOARD_SET_OFFLOAD_REPORT_REQUEST });

export const setOffloadReport = payload => ({ type: actionTypes.DASHBOARD_SET_OFFLOAD_REPORT, payload });

export const setOffloadDetailsRequesting = () => ({ type: actionTypes.DASHBOARD_SET_OFFLOAD_DETAILS_REQUEST });

export const setOffloadDetails = payload => ({ type: actionTypes.DASHBOARD_SET_OFFLOAD_DETAILS, payload });

//-----------------------------------LOADS-------------------------------------------
export const setChartViewType = data => ({ type: actionTypes.DASHBOARD_SET_CHART_VIEW_TYPE, payload: data });

export const setMainLoadViewType = data => ({ type: actionTypes.DASHBOARD_SET_SELECTED_LOAD_MAIN_VIEW, payload: data });

export const setSubLoadViewType = data => ({ type: actionTypes.DASHBOARD_SET_SELECTED_LOAD_SUB_VIEW, payload: data });

export const manualLoadRequest = () => ({ type: actionTypes.DASHBOARD_GET_MANUAL_LOAD_REQUEST });

export const manualLoad = (data, selectedPlanType) => ({ type: actionTypes.DASHBOARD_GET_MANUAL_LOAD, payload: data, selectedPlanType });

export const setHarverstSummary = (data) => ({ type: actionTypes.DASHBOARD_GET_HARVEST_SUMMARY, payload: data });

export const setHarverstSummaryRequsting = () => ({ type: actionTypes.DASHBOARD_GET_HARVEST_SUMMARY_REQUEST });

export const userRemember = data => ({ type: actionTypes.DASHBOARD_USER_REMEMBER, payload: data });

export const userRememberRequest = () => ({ type: actionTypes.DASHBOARD_USER_REMEMBER_REQUEST });

//-----------------------------------COMMON-------------------------------------------
export const getPlanTypeList = () => dispatch => {
    defaultAgent.get('/api/farm/plantype').then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
        } else if (agentResult.data) {
            dispatch(planTypeList(agentResult.data));
        } else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            dispatch(planTypeList());
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        dispatch(planTypeList());
    });
};

export const cancelPreviousDashboardRequest = () => (_, getState) => {
    const requestIds = getState().dashboard.requestIds;
    requestIds.forEach(id => defaultAgent.cancel(`dashboard_${id}`));
};

export const subscribeAnalyzeKPI = params => dispatch => {
    if (!window.socketClient) return;
    const actionList = window.socketClient.getActionList();
    const groupName = params.subscribeId ? params.subscribeId : GROUP_DASHBOARD_ANALYZE_KPI;

    if (isToday(params.range)) {
        const isSubscribed = deviceId => {
            if (actionList.hasOwnProperty(groupName)) {
                const findActions = actionList[groupName].filter(e => e.deviceId === deviceId);
                return (findActions.length > 0);
            }
            return false;
        };

        const topics = getAnalyzeTopics(params);
        const notifications = [];
        for (const item of topics) {
            if (item.subscribeDeviceId && isSubscribed(item.subscribeDeviceId)) continue;
            notifications.push({
                deviceId: item.subscribeDeviceId, name: item.topic,
                ...item.action && { action: item.action },
                ...item.parameters && { parameters: item.parameters }
            });
        }
        if (notifications.length > 0) dispatch(subscribe(notifications, groupName, true));
    } else if (actionList.hasOwnProperty(groupName))
        dispatch(unsubscribe(groupName, true));
    return;
};

export const unsubscribeAnalyzeKPI = params => dispatch => {
    dispatch(unsubscribe(params && params.subscribeId ? params.subscribeId : GROUP_DASHBOARD_ANALYZE_KPI));
    return;
};

//-------------------------------------------LEADER BOARD-------------------------------------------
export const getEquipmentGroupList = (params, cb = null) => (dispatch) => {
    if (!(params.fromDate && params.toDate)) return dispatch(equipmentGroupList());
    const reqParams = {
        farm_uuid: params.farmId,
        from_date: params.fromDate,
        to_date: params.toDate,
        crew: (params.crew || 1),
        device: (params.device || 1),
        plan_type_id: params.selectedPlanType
    };

    if (params.planTypeIds) reqParams.plan_type_id = params.planTypeIds.join(',');

    const requestId = `equipmentGroup_list`;
    dispatch(addRequestId(requestId));

    dispatch(equipmentGroupListRequest());
    defaultAgent.get('/api/equipment/group/v1/list', reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(equipmentGroupList());
            } else if (agentResult.data) {
                if (!!cb) cb(agentResult.data);
                dispatch(equipmentGroupList(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard Equipment group data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(equipmentGroupList());
        });
};

export const getManualLoadForLeaderBoard = (type, params) => dispatch => {
    let reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range,
        plan_type_id: params.planTypeId
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) return dispatch(manualLoadForLeaderBoard(type));;
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }
    const planTypeBasedType = (params.planTypeId === 2) ? (type === 'source' ? 'target' : 'source') : type;

    const requestId = `eg_load_history_${type}`;
    dispatch(addRequestId(requestId));

    dispatch(manualLoadRequestForLeaderBoard(planTypeBasedType));
    defaultAgent.get(`/api/equipment/group/load/${type}`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(manualLoadForLeaderBoard(planTypeBasedType));
            } else if (agentResult.data) {
                dispatch(manualLoadForLeaderBoard(planTypeBasedType, agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard ${planTypeBasedType} load data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(manualLoadForLeaderBoard(planTypeBasedType));
        });
};

export const getAutomaticEgLoad = params => dispatch => {
    if (!params.fromDate || !params.toDate) return dispatch(automaticEgLoad());;
    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate).endOf('day').format(),
        equipment_group_uuid: params.egIds
    };

    const requestId = `EG_load_estimate`;
    dispatch(addRequestId(requestId));

    dispatch(automaticEgLoadRequest());
    defaultAgent.post(`api/equipment/group/load/estimate/summary`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(automaticEgLoad(params.crewId));
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                dispatch(automaticEgLoad(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard Equipment group load estimate summary: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(automaticEgLoad());
        });
};

export const getSourceEgKPIData = params => dispatch => {
    if (!params.fromDate || !params.toDate) return dispatch(sourceEgElasticdata());;
    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate).endOf('day').format()
    };

    reqParams.equipment_group_uuid = params.egIds.join(',');
    reqParams.include_work = true;

    const requestId = `equipment_group_source_kpidata`;
    dispatch(addRequestId(requestId));

    dispatch(sourceEgElasticdataRequest());
    defaultAgent.post(`api/equipment/group/kpi/data`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(sourceEgElasticdata());
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                dispatch(sourceEgElasticdata(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard equipment group KPI data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(sourceEgElasticdata());
        });
};

//-------------------------------------------CREWS-------------------------------------------
export const getCrewList = params => (dispatch, getState) => {
    const search = getState().analyze.searchParams;
    const dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        plan_type_id: params.selectedPlanType
    };

    const requestId = `crew_list`;
    dispatch(addRequestId(requestId));

    dispatch(crewListRequest());
    defaultAgent.get('/api/crew/v1/list', reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(crewList());
            } else if (agentResult.data) {
                dispatch(crewList(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard crews data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(crewList());
        });
};

export const getCrewSummary = params => dispatch => {
    let reqParams = {
        farm_uuid: params.farmId,
        crew_uuid: params.crewId,
        range_type: params.range,
        ...params.plan_type_id && {
            plan_type_id: params.plan_type_id
        }
    };

    const done = response => {
        dispatch(crewSummary(params.crewId, response));
        dispatch(callCrewKPI(params, response));
        return;
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) return done();
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `crew_summary_${params.crewId}`;
    dispatch(addRequestId(requestId));

    dispatch(crewSummaryRequest(params.crewId));
    defaultAgent.get(`/api/crew/v1/summary`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                done();
            } else if (agentResult.data) {
                done(agentResult.data);
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard crew summary data: `, ex.message);
            dispatch(toastError(ex.message));
            return done();
        });
};

export const getCrewDonut = params => dispatch => {
    let reqParams = {
        farm_uuid: params.farmId,
        crew_uuid: params.crewId,
        range_type: params.range
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) return dispatch(crewDonut(params.crewId));
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `crew_donut_${params.crewId}`;
    dispatch(addRequestId(requestId));

    dispatch(crewDonutRequest(params.crewId));
    defaultAgent.get(`/api/crew/v1/donut`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(crewDonut(params.crewId));
            } else if (agentResult.data) {
                dispatch(crewDonut(params.crewId, agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard crew donut data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(crewDonut(params.crewId));
        });
};

export const getCrewGraph = params => dispatch => {
    let reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range,
        crew_uuid: params.crewId
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) return dispatch(crewGraph(params.crewId));;
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `crew_graph_${params.crewId}`;
    dispatch(addRequestId(requestId));

    dispatch(crewGraphRequest());
    defaultAgent.get(`/api/crew/v1/chart`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(crewGraph(params.crewId));
            } else if (agentResult.data) {
                dispatch(crewGraph(params.crewId, agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard crew graph data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(crewGraph(params.crewId));
        });
};

export const callCrewKPI = (params, payload) => dispatch => {
    const date = getDateRangeWith(params, payload);
    const paramsWith = { ...params, ...date };
    dispatch(getCrewKPIData(paramsWith));
    if (isElasticLoad()) dispatch(getCrewAutomaticLoad(paramsWith));
    return;
};

export const getCrewKPIData = params => dispatch => {
    if (!params.fromDate || !params.toDate) return dispatch(crewElasticData(params.crewId, "work"));
    const reqParams = {
        farm_uuid: params.farmId,
        start_date: params.fromDate,
        end_date: params.toDate,
        crew_uuid: params.crewId
    };

    const requestId = `crew_kpidata_${params.crewId}`;
    dispatch(addRequestId(requestId));

    dispatch(crewElasticDataRequest(params.crewId, "work"));
    defaultAgent.post(`api/crew/kpi/data`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(crewElasticData(params.crewId, "work"));
                dispatch(toastError(agentResult.message));
            } else if (agentResult.data) {
                const elastic = { isLive: false, data: agentResult.data };
                dispatch(crewElasticData(params.crewId, "work", elastic));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard ${params.view} KPI data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(crewElasticData(params.crewId, "work"));
        });
};

export const getCrewAutomaticLoad = params => dispatch => {
    if (!params.fromDate || !params.toDate) return dispatch(crewElasticData(params.crewId, "load"));
    const reqParams = {
        farm_uuid: params.farmId,
        start_date: params.fromDate,
        end_date: params.toDate,
        crew_uuid: params.crewId,
    };

    const requestId = `crew_load_estimate_${params.crewId}`;
    dispatch(addRequestId(requestId));

    dispatch(crewElasticDataRequest(params.crewId, "load"));
    defaultAgent.get(`api/crew/load/estimate/summary`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(crewElasticData(params.crewId, "load"));
            } else if (agentResult.data) {
                const elastic = { isLive: false, data: agentResult.data };
                dispatch(crewElasticData(params.crewId, "load", elastic));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard crew load estimate summary: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(crewElasticData(params.crewId, "load"));
        });
};

export const getUserConfiguration = params => (dispatch) => {
    dispatch(userRememberRequest());
    defaultAgent.get(`/api/user/farm/configuration?farm_uuid=${params.farmId}`)
        .then(res => {
            const agentResult = apiResponse(res, []);
            const { data } = agentResult;
            if (data && data.remember) {
                dispatch(userRemember(data.remember));
            } else {
                dispatch(userRemember(null));
            }

        });

}

export const saveUserConfiguration = params => (dispatch) => {
    defaultAgent.post(`/api/user/farm/configuration`, params)
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            }
            else if (agentResult.code === 2079) {
                dispatch(toastError(agentResult.message));
            }
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
}

//-------------------------------------------FIELDS-------------------------------------------
export const getFieldEquipmentGroupList = (params, cb = null) => (dispatch) => {
    let dateInfo = {
        from: "2015-01-01T00:00:00.000Z",
        to: moment.utc().endOf('day').format()
    };
    // if (isPlannedOrTodate(search.range)) dateInfo = { from: params.fromDate, to: params.toDate };
    // else dateInfo = getSearchDateRange(search);

    const reqParams = {
        farm_uuid: params.farmId,
        from_date: dateInfo.from,
        to_date: dateInfo.to,
        crew: (params.crew || 1),
        device: (params.device || 1)
    };

    const requestId = `fields_equipmentGroup_list`;
    dispatch(addRequestId(requestId));

    dispatch(fieldEquipmentGroupListRequest());
    defaultAgent.get('/api/equipment/group/v1/list', reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldEquipmentGroupList());
            } else if (agentResult.data) {
                if (!!cb) cb(agentResult.data);
                dispatch(fieldEquipmentGroupList(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard Fields Equipment group data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldEquipmentGroupList());
        });
};

export const getGeoRegionList = (params, cb) => dispatch => {
    const requestId = `region_list`;
    dispatch(addRequestId(requestId));

    dispatch(regionListRequest());
    defaultAgent.get('/api/geo/region/list', {
        farm_uuid: params.farmId,
        include_work_status: true,
        include_removed: false,
        geo_region_type_id: 2
    }, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(regionList([]));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data) {
                dispatch(regionList(agentResult.data));
                if (cb) cb();
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard region list data: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(regionList([]));
        });
};

export const getWorkedAcres = (params) => (dispatch) => {
    const { farmId, fromDate, toDate } = params;
    if (!fromDate || !toDate) return dispatch(workedAcres());

    let reqParams = {
        farm_uuid: farmId,
        start_date: moment.utc(fromDate).startOf('day').format(),
        end_date: moment.utc(toDate).endOf('day').format()
    };

    dispatch(workedAcresRequest(reqParams));
    const requestId = `shape_info_farm_summary_${farmId}`;
    dispatch(addRequestId(requestId));

    defaultAgent.post(`/api/farm/region-covered-summary`, reqParams, { requestId: `dashboard_${requestId}`, timeout: 2 * 60 * 1000 })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.status === 'error') {
                dispatch(workedAcres());
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.code === RECORD_FOUND.code) {
                dispatch(workedAcres(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Geo shape1 farm dashboard: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(workedAcres());
        });
};

export const getEGWorkedAcres = (params) => (dispatch) => {
    const { shapeRefId, shapeGroupId, workTypeIds, farmId, fromDate, toDate } = params;
    if (!fromDate || !toDate) return dispatch(egWorkedAcres(shapeRefId, shapeGroupId, workTypeIds));

    let reqParams = {
        farm_uuid: farmId,
        geo_region_uuid: shapeGroupId,
        work_type_id: workTypeIds,
        include_grid: true,
        start_date: moment.utc(fromDate).startOf('day').format(),
        end_date: moment.utc(toDate).endOf('day').format()
    };

    dispatch(egWorkedAcresRequest(shapeRefId, workTypeIds));
    const requestId = `shape_info_equipment_group_${shapeRefId}_${workTypeIds.join()}`;
    dispatch(addRequestId(requestId));

    defaultAgent.post(`/api/equipment/group/region-covered`, reqParams, { requestId: `dashboard_${requestId}`, timeout: 2 * 60 * 1000 })
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.status === 'error') {
                dispatch(egWorkedAcres(shapeRefId, shapeGroupId, workTypeIds));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.code === RECORD_FOUND.code) {
                dispatch(egWorkedAcres(shapeRefId, shapeGroupId, workTypeIds, agentResult.data ? agentResult.data : {}));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Geo shape equipment group dashboard: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(egWorkedAcres(shapeRefId, shapeGroupId, workTypeIds));
        });
};

export const getFieldLoads = params => dispatch => {
    if (params.selectedPlanType === 4) {
        if (isElasticLoad()) dispatch(getAutomaticLoadsForField(params));
        else dispatch(getManualLoadsForField(params));
    }
    else {
        if (isElasticLoad()) dispatch(getAutomaticSeedsForField(params));
        else dispatch(getManualSeedsForField(params));
    }
};

export const getAutomaticLoadsForField = params => dispatch => {
    if (!(params.fromDate && params.toDate)) return dispatch(fieldLoads() && dispatch(fieldLoadsTodate()));

    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate.endOf('day')).format()
    };

    const requestId = `dashboard_LoadEstimateRegionSummary`;
    dispatch(fieldLoadRequest());
    defaultAgent.post(`/api/farm/load/estimate/region/summary`, reqParams, { requestId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldLoads());
                dispatch(fieldLoadsTodate());
            } else {
                const fieldLoadsById = agentResult.data && agentResult.data.data ? agentResult.data.data : {};
                const loads = Object.keys(fieldLoadsById).map(id => ({
                    shapeRefId: id,
                    loads: fieldLoadsById[id].load_count || 0
                }));

                const loadsTodate = Object.keys(fieldLoadsById).map(data => { return { ...data } });
                dispatch(fieldLoadsTodate(loadsTodate));
                dispatch(fieldLoads(loads));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard equipment group load estimate summary: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldLoads());
        });
};

export const getManualLoadsForField = params => dispatch => {
    let reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!(params.fromDate && params.toDate)) return dispatch(fieldLoads() && dispatch(fieldLoadsTodate()));
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `dashboard_LoadHistoryForField`;
    dispatch(fieldLoadRequest());
    defaultAgent.get(`/api/plan/load/v1/history`, reqParams, { requestId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldLoads());
                dispatch(fieldLoadsTodate());
            } else if (agentResult.data) {
                const loadList = (agentResult.data.history || [])
                    .filter(e => isUUID(e.field_geo_shape_uuid) /* && e.transfer_type === 1 */);

                const fieldsById = loadList.reduce((objById, item) => {
                    const shapeId = item.field_geo_shape_uuid;
                    const prevLoads = objById[shapeId] ? objById[shapeId].loads : 0;
                    const prevLoadCapacity = objById[shapeId] ? objById[shapeId].loadCapacity : 0;
                    const prevLoadGrossWeight = objById[shapeId] ? objById[shapeId].loadGrossWeight : 0;
                    const prevLoadTareWeight = objById[shapeId] ? objById[shapeId].loadTareWeight : 0;
                    objById[shapeId] = { loads: prevLoads + 1, loadCapacity: prevLoadCapacity + item.load_capacity, loadGrossWeight: prevLoadGrossWeight + item.load_gross_weight, loadTareWeight: prevLoadTareWeight + item.tare_weight, startDate: item.start_date, endDate: item.end_date };
                    return objById;
                }, {});

                const loads = Object.keys(fieldsById).map(id => ({ shapeRefId: id, ...fieldsById[id] }));
                const loadsTodate = (agentResult.data.history || [])
                dispatch(fieldLoadsTodate(parseLoadFromManualForDashboard(loadsTodate)));
                dispatch(fieldLoads(loads));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard load history for field: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldLoads());
        });
};


export const getAutomaticSeedsForField = params => dispatch => {
    if (!(params.fromDate && params.toDate)) return dispatch(fieldLoads());

    const reqParams = {
        farm_uuid: params.farmId,
        start_date: moment.utc(params.fromDate).startOf('day').format(),
        end_date: moment.utc(params.toDate.endOf('day')).format()
    };

    const requestId = `dashboard_LoadEstimateRegionSummary`;
    dispatch(fieldLoadRequest());
    defaultAgent.post(`/api/seed/load/history`, reqParams, { requestId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldLoads());
            } else {
                const fieldLoadsById = agentResult.data && agentResult.data.data ? agentResult.data.data : {};
                const loads = Object.keys(fieldLoadsById).map(id => ({
                    shapeRefId: id,
                    loads: fieldLoadsById[id].load_count || 0
                }));
                dispatch(fieldLoads(loads));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard equipment group load estimate summary: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldLoads());
        });
};

export const getManualSeedsForField = params => dispatch => {
    let reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!(params.fromDate && params.toDate)) return dispatch(fieldLoads());
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `dashboard_LoadHistoryForField`;
    dispatch(fieldLoadRequest());
    defaultAgent.get(`/api/seed/load/history`, reqParams, { requestId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldLoads());
            } else if (agentResult.data) {
                let loadList = params.selectedPlanType === 2 ? (agentResult.data.history || []) : (agentResult.data.history || [])
                    .filter(e => isUUID(e.field_geo_shape_uuid) /* && e.transfer_type === 1 */);
                if (params.selectedPlanType === 2) {
                    let loadData = []
                    loadList.forEach((e) => {
                        if (e.load_sequence && e.load_sequence.length > 0) {
                            e.load_sequence.forEach((seq) => {
                                loadData.push({ ...seq, "field_geo_shape_uuid": seq.geo_shape_uuid });
                            })
                        }
                    })
                    loadList = loadData;
                }
                const fieldsById = loadList.reduce((objById, item) => {
                    const shapeId = item.field_geo_shape_uuid;
                    const prevLoads = objById[shapeId] ? objById[shapeId].loads : 0;
                    const prevLoadCapacity = objById[shapeId] ? objById[shapeId].loadCapacity : 0;
                    objById[shapeId] = { loads: prevLoads + 1, loadCapacity: prevLoadCapacity + item.load_capacity };
                    return objById;
                }, {});

                const loads = Object.keys(fieldsById).map(id => ({ shapeRefId: id, ...fieldsById[id] }));

                dispatch(fieldLoads(loads));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard load history for field: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldLoads());
        });
};

export const getLoadAttributionForField = params => dispatch => {
    if (!(params.fromDate && params.toDate)) return dispatch(fieldLoads());

    const reqParams = {
        farm_uuid: params.farmId,
        farm_day_start: moment.utc(params.fromDate).startOf('day').format(API_DATE_FORMAT),
        farm_day_end: moment.utc(params.toDate).endOf('day').format(API_DATE_FORMAT)
    };

    const requestId = `dashboard_LoadAttribution`;
    dispatch(fieldLoadRequest());
    defaultAgent.post(`/api/farm/load-attribution`, reqParams, { requestId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldLoads());
            } else if (agentResult.data) {
                const trips = [];
                for (const trip of agentResult.data.data || []) {
                    const tripId = `${trip.transporter_equipment_group_uuid}_${trip.farm_day}_${trip.visit_id}`;
                    for (const workWindowId of trip.work_windows) {
                        trips.push({ tripId, workWindowId });
                    }
                }
                dispatch(getWorkWindowsForField(trips));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard equipment group load attribution: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldLoads());
        });
};

export const getWorkWindowsForField = trips => (dispatch, getState) => {
    const workWindowIds = trips.map(e => e.workWindowId);
    const requestId = `dashboard_workwindow`;
    defaultAgent.post(`/api/farm/workwindow`, { work_window_uuid: workWindowIds }, { requestId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(fieldLoads());
            } else if (agentResult.data) {
                const fieldListById = getState().dashboard.field.fieldListById.payload;
                const workWindows = Array.isArray(agentResult.data.data) ? agentResult.data.data : [];
                const loads = [];

                for (const egItem of workWindows) {
                    for (const workWindow of egItem.work_windows) {
                        if (!(workWindow.shape && workWindow.shape.coordinates.length > 0)) continue;

                        const workWindowId = workWindow.work_window_uuid;
                        const findTrips = trips.filter(e => e.workWindowId === workWindowId);
                        if (findTrips.length === 0) continue;

                        const isExists = loads.some(e => e.loadId === findTrips[0].tripId);
                        if (isExists) continue;

                        const location = workWindow.shape.coordinates[0].map(e => ({ lat: e[1], lng: e[0] }));
                        const shapeId = findShape(fieldListById, location);
                        if (!shapeId) continue;
                        loads.push({
                            loadId: findTrips[0].tripId,
                            loadDate: workWindow.farm_day,
                            shapeRefId: shapeId,
                            targetEGId: workWindow.equipment_group_uuid
                        });
                    }
                }

                dispatch(fieldLoads(loads));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard work window: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(fieldLoads());
        });
};

//-------------------------------------------OFFLOAD-------------------------------------------

export const getGeoOffloadList = (farmId, includeRemoved = false, range) => dispatch => {
    const dateRange = range ? range : {};

    dispatch(setOffloadListRequesting());
    defaultAgent.get('/api/geo/region/list', { farm_uuid: farmId, include_removed: includeRemoved, geo_region_type_id: 4, ...dateRange })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(setOffloadList([], farmId));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data)
                dispatch(setOffloadList(agentResult.data, farmId));
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getOffloadReport = params => dispatch => {
    dispatch(setOffloadReportRequesting());

    defaultAgent.post(`/api/geo/offload/report`, { ...params })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(setOffloadReport([]));
                dispatch(toastError(agentResult.message));
            }
            else if (agentResult.data)
                dispatch(setOffloadReport(agentResult.data));
        }).catch(ex => {
            dispatch(toastError(ex.message));
        });
};

export const getOffloadDetails = (params, cb) => dispatch => {

    if (!cb) dispatch(setOffloadDetailsRequesting(params));
    defaultAgent.post(`/api/geo/storage/report`, params).then(res => {
        const agentResult = apiResponse(res, []);
        if (agentResult.isUnauthorized) {
            dispatch(toastError(agentResult.message));
            dispatch(tokenExpired());
            if (cb) cb([]);
        } else if (agentResult.data)
            if (agentResult && agentResult.data) {
                for (const geoShapeId of Object.keys(agentResult.data)) {
                    dispatch(setOffloadDetails({ ...params, data: agentResult.data[geoShapeId], geo_region_shape_uuid: geoShapeId }));
                }
            }
        if (cb) cb(agentResult.data);
        else if (agentResult.message) {
            dispatch(toastError(agentResult.message));
            if (cb) cb([]);
        }
    }).catch(ex => {
        dispatch(toastError(ex.message));
        if (cb) cb([]);
    });
};

//-------------------------------------------LOADS-------------------------------------------
export const getManualLoad = params => (dispatch) => {
    let reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range,
        // plan_type_id: params.selectedPlanType
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) return dispatch(manualLoad());
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `farm_load_history`;
    dispatch(addRequestId(requestId));
    dispatch(manualLoadRequest());


    let APIName = '/api/plan/load/v1/history';
    if (params && params.selectedPlanType) {
        switch (params.selectedPlanType) {
            case 5:
                APIName = '/api/logistics/load/history';
                break;
            case 2:
                APIName = '/api/seed/load/history';
                break;
            default:
                break;
        }
    };
    defaultAgent.get(`${APIName}`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(manualLoad());
            } else if (agentResult.data) {
                let history = [...agentResult.data.history]/* .filter(item => item.transfer_type === 1) */;
                history.forEach(item => {
                    if (!isUUID(item.field_geo_shape_uuid)) {
                        item.field_geo_shape_uuid = "field_unknown";
                        item.field_geo_shape_name = "Unknown";
                    }
                    if (!isUUID(item.offload_geo_shape_uuid)) {
                        item.offload_geo_shape_uuid = "offloadsite_unknown";
                        item.offload_geo_shape_name = "Unknown";
                    }
                    if (!isUUID(item.source_equipment_group_uuid)) {
                        item.source_equipment_group_uuid = "implement_unknown";
                        item.source_equipment_group_name = "Unknown";
                    }
                    if (!isUUID(item.target_equipment_group_uuid)) {
                        item.target_equipment_group_uuid = "transport_unknown";
                        item.target_equipment_group_name = "Unknown";
                    }
                    if (!isUUID(item.offload_geo_storage_location_uuid)) {
                        item.offload_geo_storage_location_uuid = "storage_unknown";
                        item.offload_geo_storage_location_name = "Unknown";
                    }
                });
                dispatch(manualLoad(parseLoadFromManualForDashboard(history), params.selectedPlanType));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard farm load history: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(manualLoad());
        });
};

export const getSeedLoad = params => (dispatch) => {
    let reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range,
        plan_type_id: params.selectedPlanType
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!params.fromDate || !params.toDate) return dispatch(manualLoad());
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }

    const requestId = `farm_load_history`;
    dispatch(addRequestId(requestId));
    dispatch(manualLoadRequest());
    defaultAgent.get(`/api/seed/load/history`, reqParams, { requestId: `dashboard_${requestId}` })
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(manualLoad());
            } else if (agentResult.data) {
                let history = [...agentResult.data.history]/* .filter(item => item.transfer_type === 1) */;
                history.forEach(item => {
                    if (!isUUID(item.field_geo_shape_uuid)) {
                        item.field_geo_shape_uuid = "field_unknown";
                        item.field_geo_shape_name = "Unknown";
                    }
                    if (!isUUID(item.offload_geo_shape_uuid)) {
                        item.offload_geo_shape_uuid = "offloadsite_unknown";
                        item.offload_geo_shape_name = "Unknown";
                    }
                    if (!isUUID(item.source_equipment_group_uuid)) {
                        item.source_equipment_group_uuid = "implement_unknown";
                        item.source_equipment_group_name = "Unknown";
                    }
                    if (!isUUID(item.target_equipment_group_uuid)) {
                        item.target_equipment_group_uuid = "transport_unknown";
                        item.target_equipment_group_name = "Unknown";
                    }
                    if (!isUUID(item.offload_geo_storage_location_uuid)) {
                        item.offload_geo_storage_location_uuid = "storage_unknown";
                        item.offload_geo_storage_location_name = "Unknown";
                    }
                });
                dispatch(manualLoad(parseLoadFromManualForDashboard(history), params.selectedPlanType));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard farm load history: `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(manualLoad());
        });
};

export const getDateRangeWith = (params, payload) => {
    const date = { fromDate: null, toDate: null };

    if (isPlannedOrTodate(params.range)) {
        if (payload && payload.start_date && payload.end_date) {
            date.fromDate = moment.utc(payload.start_date).startOf('day').format();
            date.toDate = moment.utc(payload.end_date).endOf('day').format();
        }
    }
    else if (params.fromDate && params.toDate) {
        date.fromDate = moment.utc(params.fromDate).format();
        date.toDate = moment.utc(params.toDate).format();
    }

    return date;
};

export const findShape = (fieldListById, sourceLocation) => {
    for (const shapeId in fieldListById) {
        const item = fieldListById[shapeId];
        if (item.location.length === 0) continue;
        for (const point of sourceLocation) {
            const isInside = insidePolygon({ lat: point.lat, lng: point.lng }, item.location);
            if (isInside) return shapeId;
        }
    }
    return null;
};

export const getHarvestSummary = params => (dispatch) => {
    dispatch(setHarverstSummaryRequsting());
    defaultAgent.post(`/api/farm/harvest-projection-latest`, params)
        .then(res => {
            const agentResult = apiResponse(res);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(manualLoad());
            } else if (agentResult.data) {
                const result = agentResult.data.hasOwnProperty("data") ? agentResult.data.data : [];
                let data = {};
                for (const item of result) {
                    if (!item) continue;
                    data[item.geo_region_uuid] = item;
                }
                dispatch(setHarverstSummary(data));
            }
        });
};

export const updateFieldWorkStatus = (params, cb) => dispatch => {
    const reqParams = {
        farm_uuid: params.farm_uuid,
        work_status: params.work_status.map(e => {
            const { geo_shape_uuid, ...rest } = e;
            return rest;
        })
    };
    defaultAgent.put('/api/geo/shape/work-status', reqParams)
        .then(res => {
            const agentResult = apiResponse(res, {});
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.code === FIELD_STATUS_UPDATED.code) {
                dispatch(toastSuccess(agentResult.message));
                dispatch(updateFieldWorkStatusSuccess({
                    ...params, work_status: params.work_status
                }));
            } else dispatch(toastError(agentResult.message));
            cb && cb();
        }).catch(ex => {
            dispatch(toastError(ex.message));
            cb && cb();
        });
};

export const getDashBoardTareLoads = params => dispatch => {
    let reqParams = {
        farm_uuid: params.farmId,
        range_type: params.range,
        is_tareload: params.is_tareload ? params.is_tareload : false
    };

    if (params.range === RANGE_TYPE_CUSTOM) {
        if (!(params.fromDate && params.toDate)) return dispatch(fieldLoads());
        reqParams.from_date = params.fromDate;
        reqParams.to_date = params.toDate;
    }
    const requestId = `dashboard_TareLoadHistoryForField`;
    dispatch(dashboardTareLoadRequest());
    defaultAgent.get(`/api/plan/load/v1/history`, reqParams, { requestId })
        .then(res => {
            const agentResult = apiResponse(res, []);
            if (agentResult.isUnauthorized) {
                dispatch(toastError(agentResult.message));
                dispatch(tokenExpired());
            } else if (agentResult.message) {
                dispatch(toastError(agentResult.message));
                dispatch(dashboardTareLoads());
            } else if (agentResult.data) {
                dispatch(dashboardTareLoads(agentResult.data));
            }
        }).catch(ex => {
            if (defaultAgent.isCancel(ex)) return console.log(`Dashboard tare load history : `, ex.message);
            dispatch(toastError(ex.message));
            dispatch(dashboardTareLoads());
        });
};